angular.module('ihestia-commondirectives-templates-common', []);

